import React from 'react'
import { Box, Stack, Typography, styled } from '@mui/material'

import { commify, formatEther } from 'ethers/lib/utils.js'
import Link from 'next/link'
import { ReactComponent as PendingSvg } from '@/assets/imgs/pending.svg'
import { useDepositPendingData, useWithrawPendingData } from '@/hooks/useTableData'

const Wrapper = styled(Box)`
  margin-top: 32px;
  padding: 12px 20px;
  width: 100%;
  background: #1c1f0c;
`

const Header = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Text1 = styled(Typography)`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
`

const Text2 = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  font-feature-settings: 'ss02' on, 'ss01' on, 'case' on, 'calt' off;
  color: #bfff0b;
`

const Text3 = styled(Typography)`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.01em;
  font-feature-settings: 'ss01' on, 'case' on, 'calt' off;
  color: #ffffff;
  opacity: 0.7;
`

const RecordWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 75px;
`

const PendingWrapper = styled(Box)`
  display: flex;
  align-items: center;
  column-gap: 4px;
`

const PendingHistory = () => {
  const { data } = useDepositPendingData()
  return (
    <Wrapper>
      <Header>
        <Text1>Your transfer status will be updated here in real time.</Text1>
        <Link href={'/account'}>
          <Text2>View all history →</Text2>
        </Link>
      </Header>

      <Stack spacing={12} sx={{ mt: 12 }}>
        {data &&
          data.map((item, index) => (
            <RecordWrapper key={index}>
              <Text3>{new Date(item['ctime'] * 1000).toLocaleString() || '-'}</Text3>
              <Text3>
                {item?.['real_amount'] ? commify(Number(formatEther(item['real_amount'])).toFixed(2)) : '-'} &nbsp;
                {item['coin']}
              </Text3>
              <PendingWrapper>
                <PendingSvg opacity={0.7} />
                <Text3>Pending</Text3>
              </PendingWrapper>
            </RecordWrapper>
          ))}
      </Stack>
    </Wrapper>
  )
}

export default PendingHistory
